<template>
    <b-col :md="columnSize">
        <div v-if="content.recommendation" class="recommendation">{{content.recommendation}}</div>

        <b-card overlay :img-src="getStorageUrl('/login-pages/' + content.file_path)" class="offer card-only" v-if="cardOnly">
        </b-card>

        <b-card img-left :img-src="getStorageUrl('/login-pages/' + content.file_path)" class="offer" v-else>
            <h4 class="name" v-tr>{{content.name_for_display}}</h4>
            <p class="description" v-tr>{{content.description}}</p>
            <div class="action">
                <b-btn @click="contentClicked(content)" size="sm" v-if="content.welcome_url"
                       variant="outline-secondary" target="_blank"
                       :href="content.welcome_url">
                    <span v-tr>More Info|Plus d'informations</span>
                    <i class="fas fa-arrow-right ml-1"></i>
                </b-btn>
            </div>
        </b-card>
    </b-col>
</template>

<script>
    import Network from '../../vue-components/helpers/Network'

    export default {
        name: `card-content`,
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                dealerInfo: null,
                contents: null,
                giftOpened: false,
                giftShaking: false,
                birthdayModal: false,
                showGift: false
            }
        },
        computed: {
            columnSize() {
                return this.cardOnly ? 2 : 4;
            },
            cardOnly() {
                return !this.content.name_for_display && !this.content.description;
            }
        },
        methods: {
            contentClicked(content) {
                Network.post(`/wifi-portal/interactions/click`, {
                    session: this.$store.state.session,
                    content_id: content.content_id
                }).catch(() => {

                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .recommendation {
        text-align: center;
        font-size: 9pt;
        letter-spacing: 1px;
        font-weight: 500;
        color: #777;

        margin-top: 5px;

        .badge {
            width: 12px;
            height: 12px;
            margin-right: 5px;
            display: inline-block;
        }
    }

    .offer {
        height: 375px;
        overflow: hidden;

        .card-img-left {
            height: 100%;
            width: 40%;
            max-width: 280px;
            object-fit: cover;
            border-top-left-radius: inherit;
            border-bottom-left-radius: inherit;
        }

        .card-body {
            padding: 1rem;
            display: flex;
            flex-direction: column;

            h4 {
                font-size: 1.4rem;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 2;
            }

            .description {
                height: 114px;
                overflow: hidden;
                font-size: 10pt;
                flex: 4;
            }

            .action {
                text-align: right;
            }
        }
    }

    @media(max-width: 576px) {
        .offer {
            margin-bottom: 0;
        }
    }
</style>
